import { variableSearch } from '../../../const';
import {
  defaultTtsVoice,
  Design,
  DesignModuleNode,
  DesignObject,
  WorkflowPrompt
} from '../../../types';
import { getPromptVoiceChannel } from '../prompt';

export function getWfsPrompt(
  serialized: Design,
  nodeOrObject: DesignModuleNode | DesignObject
): WorkflowPrompt[] {
  const {
    components: { objects },
    languages
  } = serialized;
  let { name, props } = nodeOrObject;
  const object = ('wftName' in nodeOrObject) ? nodeOrObject : (
    objects.find((obj) => {
      return obj.id === nodeOrObject.props.parentComponentID;
    })
  );
  if (object?.wftName) {
    name = object.wftName;
  }
  let {
    inputs: rawInputs = []
  } = props.config;

  const inputs = rawInputs.map(({ argumentName, defaultValue, speakAs }) => {
    return {
      name: argumentName,
      defaultValue,
      domain: speakAs
    };
  });
  const textObject = getPromptVoiceChannel({ promptNodeConfig: props.config, serialized });

  const prompt: WorkflowPrompt = {
    name,
    inputs,
    text: {},
    readyForActivation: true
  };
  // Fallback prompts have their text split up by variables just in case TTP fails.
  const fallbackPrompts: WorkflowPrompt[] = [];

  languages.map(({ language }) => {
    let languageTextObject = textObject?.[language] ?? {};
    languageTextObject = (typeof languageTextObject === 'string') ? (
      languageTextObject.replace(/\s+/g, ' ').trim()
    ) : languageTextObject;

    if (!languageTextObject) {
      return;
    }
    const languageString = (
      typeof languageTextObject === 'string'
    ) ? languageTextObject : languageTextObject[defaultTtsVoice]?.text ?? '';

    if (!languageString) {
      return;
    }
    prompt.text[language] = languageTextObject;
    const splitText = languageString.split(variableSearch);
    if (splitText.length < 2) {
      return;
    }

    splitText.filter((textSegment, index) => {
      return (
        !!textSegment.trim()
        // `* 4` to skip capture groups.
        && index % 4 === 0
      );
    }).forEach((textSegment, index) => {
      if (!fallbackPrompts[index]) {
        fallbackPrompts.push({
          name: `${name}_TTP_FALLBACK_${index + 1}`,
          inputs: [],
          text: {},
          readyForActivation: true
        });
      }
      fallbackPrompts[index].text[language] = textSegment;
    });
  });

  return [
    prompt,
    ...fallbackPrompts
  ];
}
